import * as colors from '../../colors';
import { generateBrandClientConfig } from '../baseClient';
import { prepareSVGAsDataURI } from '../helpers';

const createLogo = (color = colors.navy) => prepareSVGAsDataURI(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 175 40"><path d="M42.5 32.9c-3.5 0-6.3-2.9-6.3-6.6 0-3.7 2.8-6.6 6.3-6.6s6.4 3 6.4 6.6c0 3.7-2.9 6.6-6.4 6.6m0-20.3c-7.5 0-13.6 6.1-13.6 13.7S35 40 42.5 40s13.6-6.1 13.6-13.7c0-7.5-6.1-13.7-13.6-13.7m59.2 20.5c-3.9 0-6.8-2.9-6.8-6.8s2.9-6.8 6.8-6.8c3.7 0 6.5 2.9 6.5 6.8-.1 3.8-2.9 6.8-6.5 6.8m6.2-17.6c-1.9-1.8-4.6-2.8-7.6-2.8-6.4 0-12.8 4.7-12.8 13.7 0 5.3 2.3 8.5 4.2 10.3 2.3 2.1 5.5 3.4 8.4 3.4 3 0 5.8-1.1 7.7-3.2v2.6h7.4V0h-7.4v15.5zm24.9 17.4c-3.5 0-6.3-2.9-6.3-6.6 0-3.7 2.8-6.6 6.3-6.6s6.4 3 6.4 6.6c0 3.7-2.9 6.6-6.4 6.6m0-20.3c-7.5 0-13.6 6.1-13.6 13.7 0 7.5 6.1 13.7 13.6 13.7s13.6-6.1 13.6-13.7c0-7.5-6.1-13.7-13.6-13.7M72.9 32.9c-3.6 0-6.5-2.9-6.5-6.6 0-3.7 2.9-6.6 6.5-6.6 2.3 0 4.4 1.2 5.5 3.2l6.1-3.8c-2.4-4-6.8-6.5-11.7-6.5-7.5 0-13.6 6.1-13.6 13.7 0 7.5 6.1 13.7 13.6 13.7 5 0 9.3-2.4 11.7-6.5l-6.1-3.8c-1.1 2-3.2 3.2-5.5 3.2m90.3 0c-3.6 0-6.5-2.9-6.5-6.6 0-3.7 2.9-6.6 6.5-6.6 2.3 0 4.4 1.2 5.5 3.2l6.1-3.8c-2.4-4-6.8-6.5-11.7-6.5-7.5 0-13.6 6.1-13.6 13.7 0 7.5 6.1 13.7 13.6 13.7 5 0 9.3-2.4 11.7-6.5l-6.1-3.8c-1.1 2-3.2 3.2-5.5 3.2M23.9 11.1l2.3-3.3.1-.2c.2-.3.3-.6.3-.9V0H.1v7.3h17.5l-1.9 2.6-11 15.9-4.1 5.9-.1.2c-.2.3-.3.6-.3.9v6.8h26.4v-7.3H9l3.4-4.8 11.5-16.4z" fill="${color}"/></svg>`
);

export default generateBrandClientConfig({
    allowSignIn: true,
    components: {
        SeoBreadcrumbLinks: {
            enabled: true,
        },

        SeoHeader: {
            linkColor: colors.navy,
            linkColorHover: colors.navy,
            linkColorVisited: colors.navy,
            linkUnderlineColor: colors.navy,
            linkUnderlineColorHover: colors.navy,
            linkUnderlineColorVisited: colors.navy,
        },

        SeoRelatedLinks: {
            enabled: true,
        },
    },

    faviconUri: 'https://www.zocdoc.com/favicon.ico',

    languages: {
        ENGLISH: {
            host: 'www.zocdoc.com',
            hreflang: 'en',
        },
        SPANISH: {
            host: 'espanol.zocdoc.com',
            hreflang: 'es',
        },
    },

    header: {
        showLoginDropdown: true,
        logo: {
            uri: createLogo(),
            sizing: {
                // all except the first one are optional
                // change the sizing as desired per breakpoint
                // [height, width] tuple
                xxsmall: [16, 71],
                xsmall: null,
                small: [24, 106],
                medium: null,
                large: null,
                xlarge: null,
                xxlarge: null,
            },
        },
    },

    profile: {
        allowedStatuses: [2, 60, 61],
        showPracticeLinks: true,
        iBubblesText: {
            Name: null,
            Specialties: null,
            InNetworkInsurance: null,
            Practice: null,
            HospitalAffiliations: null,
            Certifications: null,
            Sex: null,
            OfficeLocations: null,
        },
        sectionDefaultValue: null,
        locationInfo: {
            markdown: null,
        },
        showPhoneNumberIfNotBookableOrNotAvailable: false,
        unbookableSection: {
            markdown: null,
        },
    },
});
